<script>
    import { faEdit, faPen } from "@fortawesome/free-solid-svg-icons";
    import { createEventDispatcher } from "svelte";
    import Fa from "svelte-fa";
    import Button from "../ui/Button.svelte";
    import ClickablePanel from "../ui/ClickablePanel.svelte";
    import EditStamp from "./EditStamp.svelte";
    import RemoveStamp from "./RemoveStamp.svelte";
    import ShowLogin from "./ShowLogin.svelte";
    import State from "./State.svelte";
    import Stamp from "./Stamp.svelte";

    export let stamp;
    const size = 60;

    const dispatch = createEventDispatcher();
    let showCode = false;

    $: totalCount = getTotalCount( stamp.rarities );

    
    function getTotalCount( rarities ) {
        let count = 0; 
        for (let key in rarities) {
            if (rarities[key].hasOwnProperty('count')) {
                count += rarities[key].count;
            }
        }
        return count;
    }

    $: editable = totalCount === 0;
    let editing = false;
</script>

<ClickablePanel on:open={() => {editing = true}} disabled={!editable}>
    <div class="container">
        <div class="header">
            <div class="title">
                <div class="headline">
                    <h2>{stamp.name??"Unbenannter Stempel"}</h2>
                    <State state={stamp.state} />
                </div>
                <span class="about">
                    {#if totalCount === 0}
                        Noch nicht vergeben
                    {:else}
                        Insgesamt {totalCount} Mal vergeben
                    {/if}
                </span>
            </div>
            <div class="actions">
                {#if editable}
                    <EditStamp {stamp} on:edit={(e) => dispatch("edit", e.detail)} bind:open={editing}/>
                {/if}
                <RemoveStamp {stamp} on:remove={(e) => dispatch("remove", e.detail)}/>
            </div>
        </div>
        <div>
        </div>
        <div class="content">
            <Stamp img_src={stamp.img_src} rarity={"common"} exists={stamp.available_rarities?.includes("common")} />
            <Stamp img_src={stamp.img_src} rarity={"rare"} exists={stamp.available_rarities?.includes("rare")} />
            <!-- <Stamp img_src={stamp.img_src} rarity={"epic"} exists={stamp.rarities.includes("epic")} />
            <Stamp img_src={stamp.img_src} rarity={"legendary"} exists={stamp.rarities.includes("legendary")} /> -->
        </div>
    </div>
</ClickablePanel>

<style>
    .container {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 1rem;
    }

    .title {
        display: flex;
        flex-direction: column;
    }

    .headline {
        display: flex;
        align-items: center;
        gap: 0.7rem;
        line-break: strict;
        text-overflow: ellipsis;
    }

    .about {
        font-size: 0.8rem;
    }

    .actions {
        margin-top: -0.25rem;
    }

    h2 {
        margin: 0;
        line-height: 1;
    }

    img {
        /* width: 100%;
        height: 100%; */
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        transform: rotate(-5deg);
    }

    .content {
        display: flex;
        gap: 1.5rem;
    }
</style>